import React from 'react';

export const DragHandleDistractor = (props) => {
    const { dragHandleProps } = props;
    return (
        <div
            {...dragHandleProps}
            style={{ display: "none" }}
        />
    )
}